import { createSlice } from '@reduxjs/toolkit';
import { get, post } from 'api/fetch';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'global/NPS',
  initialState: {
    isLoading: false,
    error: null,
    npsSubmitted: false
  },
  reducers: {
    sendNPSRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    sendNPSSuccess: (state) => {
      state.isLoading = false;
      state.error = null;
      state.npsSubmitted = true;
    },
    sendNPSFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    checkNPSSubmittedRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    checkNPSSubmittedSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.npsSubmitted = payload;
    },
    checkNPSSubmittedFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    setNPSSubmitted: (state, { payload }) => {
      state.npsSubmitted = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const checkNPSSubmitted = (campaign, product, claimId) => async (dispatch) => {
  dispatch(actions.checkNPSSubmittedRequest());
  try {
    const response = await get(`/feedback/nps?campaign=${campaign}`);
    let npsSubmitted = false;

    if (campaign === 'claims_ni') {
      npsSubmitted = response.some((r) => r.claimId === Number(claimId));
    } else {
      npsSubmitted = response.some((r) => r.product === product);
    }

    dispatch(actions.checkNPSSubmittedSuccess(npsSubmitted));
  } catch (error) {
    dispatch(actions.checkNPSSubmittedFailure(error));
  }
};

export const sendNPS = (npsInfo) => async (dispatch) => {
  dispatch(actions.sendNPSRequest());
  try {
    await post('/feedback/nps', npsInfo);
    dispatch(actions.sendNPSSuccess());
  } catch (error) {
    dispatch(actions.sendNPSFailure(error));
  }
};

export const setNPSSubmitted = (state) => (dispatch) => {
  dispatch(actions.setNPSSubmitted(state));
};
